module.exports = __webpack_public_path__ + "img/1.03c5a9c2.png";